import Page from "./Page.vue";
import * as XLSX from "xlsx";

function getRating(point) {
  if (point >= 25) return { name: "H", color: "#E42728" };
  else if (point >= 15) return { name: "M", color: "#EA5455" };
  else if (point >= 5) return { name: "L", color: "#FF9F43" };
  else return { name: "N", color: "#28C76F" };
}

function getBodyFromItem(item) {
  if (!item) return {};
  if (item.postContents && item.postContents.body) {
    return item.postContents.body;
  }
  if (item.post && item.post.post_content) {
    try {
      const parsed = JSON.parse(item.post.post_content);
      return (parsed && parsed.body) || {};
    } catch (e) {
      // ignore parse error
    }
  }
  if (item.post_content) {
    try {
      const parsed = JSON.parse(item.post_content);
      return (parsed && parsed.body) || {};
    } catch (e) {
      // ignore parse error
    }
  }
  return {};
}

function joinMultiline(values) {
  return values
    .map((v) => {
      if (v === null || v === undefined) return "";
      return `${v}`;
    })
    .filter((v) => v !== "")
    .join("\n");
}

function buildExcelRow(item, idx) {
  const body = getBodyFromItem(item);
  const stdInfo = body.stdInfo || {};
  const 에너지검토분류 = body["에너지검토분류"] || {};
  const 에너지평가 = Array.isArray(body["에너지평가"]) ? body["에너지평가"] : [];

  const 설비명들 = joinMultiline(에너지평가.map((e) => e && e["설비명"]));
  const 사용에너지들 = joinMultiline(에너지평가.map((e) => e && e["사용에너지"]));
  const 계측가능여부들 = joinMultiline(에너지평가.map((e) => e && e["계측가능여부"]));
  const 중요에너지등록여부들 = joinMultiline(
    에너지평가.map((e) => {
      if (e && (e["평가품목_평가점수"] >= 18 || e["평가품목_사용량_점수"] === 3)) return "Y";
      return "N";
    })
  );

  const 설비수 = 에너지평가.length;
  // 중요(M등급 이상) 개수: Write.vue 의 등급 계산식과 동일하게 평가점수/사용량점수 기준으로 판정.
  // (오래된 문서는 평가품목_등급 필드가 "-" 로 저장되어 있는 경우가 있어 직접 점수 기반으로 다시 계산)
  const 중요등급_개수 = 에너지평가.filter((e) => e && (Number(e["평가품목_평가점수"]) >= 18 || Number(e["평가품목_사용량_점수"]) === 3)).length;

  const row = {};
  row["No."] = idx + 1;
  row["사업장명"] = stdInfo.field_name || "";
  row["소속2"] = stdInfo.department || "";
  row["공정"] = 에너지검토분류["공정명"] || "";
  row["설비명"] = 설비명들;
  row["사용에너지"] = 사용에너지들;
  row["계측 가능여부"] = 계측가능여부들;
  row["중요에너지등록여부"] = 중요에너지등록여부들;
  row["작성자"] = stdInfo.writer_name || "";
  row["중요(M등급 이상) 개수"] = 중요등급_개수;
  row["설비수"] = 설비수;
  return row;
}

const list = {
  summaryComponent: Page,
  // 미리보기용 — 화면 표시 No. 와 동일하게 가장 오래된 문서가 1번
  getExcelList(parsedListForTable, listAllExcel) {
    const sorted = (Array.isArray(listAllExcel) ? listAllExcel : []).slice().reverse();
    return sorted.map((item, idx) => buildExcelRow(item, idx));
  },
  customExcelDownload(data, fileName, listAllExcel) {
    // listAllExcel 은 최신순(desc) 으로 정렬되어 들어옴.
    // 화면 목록은 가장 오래된 문서를 No.=1 로 표기하므로, 엑셀도 No.=1 부터 첫 줄에 오도록 역순으로 출력한다.
    const list = (Array.isArray(listAllExcel) ? listAllExcel : []).slice().reverse();

    const headers = ["No.", "사업장명", "소속2", "공정", "설비명", "사용에너지", "계측 가능여부", "중요에너지등록여부", "작성자", "중요(M등급 이상) 개수", "설비수"];
    const rows = [headers];

    list.forEach((item, idx) => {
      const body = getBodyFromItem(item);
      const stdInfo = body.stdInfo || {};
      const 에너지검토분류 = body["에너지검토분류"] || {};
      const 에너지평가 = Array.isArray(body["에너지평가"]) ? body["에너지평가"] : [];

      const 설비명들 = joinMultiline(에너지평가.map((e) => e && e["설비명"]));
      const 사용에너지들 = joinMultiline(에너지평가.map((e) => e && e["사용에너지"]));
      const 계측가능여부들 = joinMultiline(에너지평가.map((e) => e && e["계측가능여부"]));
      const 중요에너지등록여부들 = joinMultiline(
        에너지평가.map((e) => {
          if (e && (e["평가품목_평가점수"] >= 18 || e["평가품목_사용량_점수"] === 3)) return "Y";
          return "N";
        })
      );

      const 설비수 = 에너지평가.length;
      const 중요등급_개수 = 에너지평가.filter((e) => e && e["평가품목_등급"] === "M").length;

      rows.push([idx + 1, stdInfo.field_name || "", stdInfo.department || "", 에너지검토분류["공정명"] || "", 설비명들, 사용에너지들, 계측가능여부들, 중요에너지등록여부들, stdInfo.writer_name || "", 중요등급_개수, 설비수]);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  },
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "Head 3"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "created_at", operator: ">=", value: `${search.year}-01-01` });
      conditions.push({ key: "created_at", operator: "<", value: `${parseInt(search.year) + 1}-01-01` });
    }

    // 사업장
    const params = new URLSearchParams(window.location.search);
    const fd = params.get("fd");
    conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: fd });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "공정",
        key: "body.에너지검토분류.공정명",
      },
      {
        name: "설비명",
        key: "body.에너지평가[%].설비명",
      },
      {
        name: "사용에너지",
        key: "body.에너지평가[%].사용에너지",
      },
      {
        name: "계측 가능여부",
        key: "body.에너지평가[%].계측가능여부",
      },
      {
        name: "중요에너지등록여부",
        key: "body.에너지평가[%].평가품목_중요에너지등록부분류",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 3) {
          const 설비명 = func.getContent(value).에너지평가.map((e) => e.설비명);

          const list = 설비명
            .reduce((acc, cur, i) => {
              if (i % 3 === 0) acc.push([]);
              acc[acc.length - 1].push(cur);
              return acc;
            }, [])
            .map((group) => group.join(", "))
            .join("\n");
          return {
            type: "pre",
            value: list,
          };
        } else if (index === 4) {
          const 사용에너지 = func.getContent(value).에너지평가.map((e) => e.사용에너지);

          const list = 사용에너지
            .reduce((acc, cur, i) => {
              if (i % 3 === 0) acc.push([]);
              acc[acc.length - 1].push(cur);
              return acc;
            }, [])
            .map((group) => group.join(", "))
            .join("\n");
          return {
            type: "pre",
            value: list,
          };
        } else if (index === 5) {
          const 계측가능여부 = func.getContent(value).에너지평가.map((e) => e.계측가능여부);

          const list = 계측가능여부
            .reduce((acc, cur, i) => {
              if (i % 3 === 0) acc.push([]);
              acc[acc.length - 1].push(cur);
              return acc;
            }, [])
            .map((group) => group.join(", "))
            .join("\n");
          return {
            type: "pre",
            value: list,
          };
        } else if (index === 6) {
          const 중요에너지등록여부 = func.getContent(value).에너지평가.map((e) => (e.평가품목_평가점수 >= 18 || e.평가품목_사용량_점수 === 3 ? "Y" : "N"));

          const list = 중요에너지등록여부
            .reduce((acc, cur, i) => {
              if (i % 3 === 0) acc.push([]);
              acc[acc.length - 1].push(cur);
              return acc;
            }, [])
            .map((group) => group.join(", "))
            .join("\n");
          return {
            type: "pre",
            value: list,
          };
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
